export default __webpack_public_path__ + "static/media/Guidance.d242f036.png";